$(function () {
    $.fn.validateform = async (validate) => {
        let check = true;
        let check_arr = [];
        let check_password = '';
        let confim_password = '';
        let form_password = [];
        let count = validate.length

        await $.each(validate, async function (indexInArray, element) {
            check = true;
            let val = $(element).val();
            let type = $(element).attr('validate-type');

            // ตรวจสอบค่าว่าง รวมถึง array ที่ว่าง (สำหรับ multi-select)
            let isEmpty = false;

            if (val == '' || val == null || val == 'เลือก' || val === undefined) {
                isEmpty = true;
            } else if (Array.isArray(val)) {
                // ถ้าเป็น array ว่าง
                if (val.length === 0) {
                    isEmpty = true;
                } else {
                    // ตรวจสอบว่า array มีแต่ค่าว่างหรือไม่
                    const hasValidValue = val.some(v => v !== '' && v !== null && v !== undefined && v !== 'เลือก');
                    if (!hasValidValue) {
                        isEmpty = true;
                    }
                }
            }

            if (isEmpty) {
                $(element).parent().find('.invalid-feedback').show();
                $(element).parent().find('input,select,textarea,.select2-selection').addClass('border-danger');
                if ($(element).parent().hasClass('easy-autocomplete')) {
                    $(element).parent().parent().find('.invalid-feedback').show();
                    $(element).parent().parent().find('input,select,textarea,.select2-selection,.input-schedule').addClass('border-danger');
                }
                check = false;
            } else {
                if (type == 'email') {
                    check = await $.fn.validateemail(element);
                } else if (type == 'url') {
                    check = await $.fn.validateurl(element);
                } else if (type == 'check-password') {
                    form_password.push($(element).val());
                    check_password = $(element).val();
                } else if (type == 'confirm-password') {
                    form_password.push($(element).val());
                    confim_password = $(element).val();
                    if (form_password.length > 1) {
                        check = await $.fn.validatepassword(check_password, confim_password);
                    }
                } else if (type == 'datepicker') {
                    check = await $.fn.validatedatepicker(val);
                } else if (type == 'cid') {
                    check = await $.fn.validatecid(val);
                }

                if (check) {
                    $(element).parent().find('.invalid-feedback').hide();
                    $(element).parent().find('input,select,textarea,.select2-selection').removeClass('border-danger');
                    if ($(element).parent().hasClass('easy-autocomplete')) {
                        $(element).parent().parent().find('.invalid-feedback').hide();
                        $(element).parent().parent().find('input,select,textarea,.select2-selection,.input-schedule').removeClass('border-danger');
                    }
                } else {
                    $(element).parent().find('.invalid-feedback').show();
                    $(element).parent().find('input,select,textarea,.select2-selection').addClass('border-danger');
                    if ($(element).parent().hasClass('easy-autocomplete')) {
                        $(element).parent().parent().find('.invalid-feedback').show();
                        $(element).parent().parent().find('input,select,textarea,.select2-selection,.input-schedule').addClass('border-danger');
                    }
                }
            }

            if (val != null) {
                if (val.includes('PM') || val.includes('AM')) {
                    check = true;
                }
            }

            if (check) {
                check_arr.push($(element))
            }
        });

        if (check_arr.length == count) {
            check = true;
        } else {
            check = false;
        }

        return check;
    }

    $(document).on('change', '.validate', function (e) {
        $(this).parent().find('.invalid-feedback').hide();
        $(this).parent().find('input,select,textarea,.select2-selection,.input-schedule').removeClass('border-danger');
        if ($(this).parent().hasClass('easy-autocomplete')) {
            $(this).parent().parent().find('.invalid-feedback').hide();
            $(this).parent().parent().find('input,select,textarea,.select2-selection,.input-schedule').removeClass('border-danger');
        }
    })

    $.fn.validateemail = (emailElem) => {
        const regex = /\S+@\S+\.\S+/;
        if (!regex.test($(emailElem).val())) {
            return false;
        } else {
            return true;
        }
    }

    $.fn.validatepassword = (password, confirm) => {
        if (password != confirm) {
            return false;
        } else {
            return true;
        }
    }

    $.fn.validatedatepicker = (val) => {
        if (val != '') {
            return true;
        } else {
            return false;
        }
    }

    $.fn.validatecid = (id) => {
        if (id.length != 13) return false;
        for (i = 0, sum = 0; i < 12; i++)
            sum += parseFloat(id.charAt(i)) * (13 - i);
        if ((11 - sum % 11) % 10 != parseFloat(id.charAt(12)))
            return false;
        return true;
    }

    $.fn.validateurl = (urlElem) => {
        const val = $(urlElem).val().trim();
        if (!val) return true; // ถ้าไม่มีค่า ให้ผ่าน (เพราะเป็น optional field)
        
        try {
            new URL(val);
            return true;
        } catch {
            return false;
        }
    }

});